import { when } from '@execonline-inc/maybe-adapter';
import { eq } from '@execonline-inc/numbers';
import { observer } from 'mobx-react';
import ImportParticipantsStore from '../../../Store';
import { ImportedParticipants } from '../../../Store/Types';
import AlertImport from '../AlertImport';
import FailedImport from '../FailedImport';

interface Props {
  importedParticipants: ImportedParticipants;
  totalCount: number;
  store: ImportParticipantsStore;
}

const importFailed = (total: number, failed: number) => when(eq(total)(failed), {});

function FailedAlertImport({ importedParticipants, totalCount, store }: Props) {
  const { failedParticipants, formattingIssue, participantsOfDifferentOrg, participantsOfSameOrg } =
    importedParticipants;

  const failedParticipantsCount =
    failedParticipants.length +
    formattingIssue.length +
    participantsOfDifferentOrg.length +
    participantsOfSameOrg.length;

  return importFailed(totalCount, failedParticipantsCount)
    .map(() => (
      <FailedImport
        importedParticipants={importedParticipants}
        totalCount={totalCount}
        store={store}
      />
    ))
    .getOrElse(() => (
      <AlertImport
        importedParticipants={importedParticipants}
        totalCount={totalCount}
        store={store}
      />
    ));
}

export default observer(FailedAlertImport);
